import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { Field, inputClasses } from './Field';
interface SelectFieldProps {
  id: string;
  label: string;
  value: string;
  options: string[];
  onChange: (value: string) => void;
  placeholder?: string;
  required?: boolean;
  error?: string;
  hint?: string;
  className?: string;
}
export function SelectField({
  id,
  label,
  value,
  options,
  onChange,
  placeholder = 'Select an option',
  required,
  error,
  hint,
  className
}: SelectFieldProps) {
  return <Field id={id} label={label} required={required} error={error} hint={hint} className={className} data-id="element-109" data-mp="1eb1vlzh8kh3c">
      <div className="relative" data-id="element-110" data-mp="1o7xwbj0w7yxc">
        <select id={id} name={id} value={value} aria-required={required} aria-invalid={Boolean(error)} aria-describedby={error ? `${id}-error` : hint ? `${id}-hint` : undefined} onChange={e => onChange(e.target.value)} className={inputClasses(Boolean(error), `appearance-none pr-9 ${value ? '' : 'text-ink-400'}`)} data-id="element-111" data-mp="1o7ofakxtt23s">
          <option value="" data-id="element-112" data-mp="qwendj6clvve">{placeholder}</option>
          {options.map(option => <option key={option} value={option} data-id="element-113" data-mp="uwor0p6o4a73">
              {option}
            </option>)}
        </select>
        <ChevronDownIcon aria-hidden="true" className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-400" data-id="element-114" data-mp="zsm6yue0rejc" />
      </div>
    </Field>;
}